import React from "react";
import { motion } from "framer-motion";
import { Check, Minus } from "lucide-react";
import { COMPARISON } from "../data/tiers";

const Cell = ({ value, pro }) => {
  if (value === true) return <Check size={18} className={pro ? "text-emerald mx-auto" : "text-cyan mx-auto"} strokeWidth={2.5} />;
  if (value === false) return <Minus size={16} className="text-[var(--text-faint)] mx-auto" />;
  return <span className={`font-display font-600 ${pro ? "text-white" : "text-white/85"}`}>{value}</span>;
};

const EliteHeader = () => (
  <th className="py-5 px-3 text-center relative" data-testid="elite-column-header">
    <div className="absolute inset-x-1 top-0 bottom-[-1px] bg-[rgba(212,175,55,0.07)] border-t-2 border-gold pointer-events-none" />
    <div className="relative flex flex-col items-center gap-1.5">
      <span className="eyebrow text-[0.5rem] !tracking-[0.14em] px-2 py-0.5 border border-[rgba(212,175,55,0.5)] text-gold text-center leading-tight" data-testid="elite-value-badge">
        <span className="block whitespace-nowrap">BIGGEST SAVINGS</span>
        <span className="block whitespace-nowrap">BEST VALUE</span>
      </span>
      <span className="font-display text-sm font-700 tracking-widest text-gold">ELITE</span>
    </div>
  </th>
);

const ComparisonRow = ({ row, isLast }) => (
  <tr className="border-b border-[var(--border)]">
    <td className="py-4 pr-4 text-sm text-white/80">{row.label}</td>
    <td className="py-4 px-3 text-center text-sm"><Cell value={row.network} /></td>
    <td className="py-4 px-3 text-center text-sm relative">
      <div className={`absolute inset-x-1 top-0 bottom-0 bg-[rgba(0,212,255,0.05)] pointer-events-none ${isLast ? "border-b-2 border-cyan" : ""}`} />
      <span className="relative"><Cell value={row.pro} pro /></span>
    </td>
    <td className="py-4 px-3 text-center text-sm relative">
      <div className={`absolute inset-x-1 top-0 bottom-0 bg-[rgba(212,175,55,0.07)] pointer-events-none ${isLast ? "border-b-2 border-gold" : ""}`} />
      <span className="relative"><Cell value={row.elite} /></span>
    </td>
  </tr>
);

export const ComparisonTable = () => {
  return (
    <section className="relative py-20 sm:py-28 grain" data-testid="comparison-table">
      <div className="max-w-5xl mx-auto px-5">
        <motion.h2
          className="font-display text-3xl sm:text-5xl font-700 tracking-tight text-white text-center leading-[1.05] mb-16"
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7 }}
        >
          THE DEEPER YOU GO,<br />
          <span className="text-dim">THE MORE YOU UNLOCK.</span>
        </motion.h2>

        <motion.div
          className="relative overflow-x-auto"
          initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}
        >
          <table className="w-full border-collapse min-w-[560px]">
            <thead>
              <tr className="border-b border-[var(--border-strong)]">
                <th className="text-left py-5 pr-4 eyebrow text-dim font-500">Benefit</th>
                <th className="py-5 px-3 font-display text-sm font-700 tracking-widest text-white text-center">NETWORK</th>
                <th className="py-5 px-3 text-center relative">
                  <div className="absolute inset-x-1 top-0 bottom-[-1px] bg-[rgba(0,212,255,0.05)] border-t-2 border-cyan pointer-events-none" />
                  <span className="relative font-display text-sm font-700 tracking-widest text-cyan">PRO</span>
                </th>
                <EliteHeader />
              </tr>
            </thead>
            <tbody>
              {COMPARISON.map((row, i) => (
                <ComparisonRow key={row.label} row={row} isLast={i === COMPARISON.length - 1} />
              ))}
            </tbody>
          </table>
        </motion.div>
      </div>
    </section>
  );
};
